import { v4 as uuidv4 } from 'uuid';

export const getOldNewIdPairs = <TItem>(
  items: TItem[],
  _for: (item: TItem) => string
): { [oldId: string]: string } => {
  return items.reduce((result, i) => ({ ...result, [_for(i)]: uuidv4() }), {});
};
